import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import {
  FormsModule,
  ReactiveFormsModule
} from '@angular/forms';
import { RouterModule } from '@angular/router';
import { NgSelectModule } from '@ng-select/ng-select';
import {
  I18nModule,
  UrlModule
} from '@spartacus/core';
import { FormErrorsModule } from '@spartacus/storefront';
import { FormModule } from '@spartacus/organization/administration/components';
import { UigUserFormComponent } from './uig-user-form.component';
import { UigUserToggleStatusModule } from '../../shared/components/detail/uig-org-toggle-status/uig-user-toggle-status.module';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    FormModule,
    NgSelectModule,
    UrlModule,
    I18nModule,
    FormsModule,
    ReactiveFormsModule,
    FormErrorsModule,
    UigUserToggleStatusModule
  ],
  declarations: [UigUserFormComponent],
  exports: [UigUserFormComponent],
})
export class UigUserFormModule { }
